import $ from 'jquery';
import { scrollToElement } from '../utils/scroll-to-element';
export default class ScrollTo {
    static $element = $('.js__scroll-to');
    static init() {
        this.$element.on('click', event => {
            const $element = $(event.currentTarget);
            const $scrollToElement = $($element.data('target'));
            const $scrollToElementCollapse = $scrollToElement.closest('.collapse');
            const isInCollapse = $scrollToElementCollapse.length > 0;
            const offset = $element.data('offset') || undefined;
            if (isInCollapse) {
                $scrollToElementCollapse.collapse('show');
            }
            scrollToElement($scrollToElement, offset);
        });
    }
}
